import styled from "styled-components";

export const HeaderWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    //height: ${(props) => (props.$useShortlist ? "10rem" : "6rem")};
    height: 10rem;
    border-bottom: 1px solid ${(props) => props.theme.BorderColor};
    padding: 1rem 3rem;
    width: 100vw;
    z-index: 80;
    background-color: ${(props) => props.theme.LayoutBodyBackground};

    .header-left {
        flex: 0 0 0;
        /* border-right: 1px solid ${(props) => props.theme.BorderColor}; */
        height: ${(props) => (props.$useShortlist ? "10rem" : "6rem")};
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: relative;
    }

    .header-middle {
        flex: 1 1 0;
        .header-html-content {
            font-size: 1rem;
            line-height: 1.25rem;
            color: ${(props) => props.theme.TextColor};
        }
    }
    .header-right {
        //min-width: 24rem;
        flex: 0 1 1;
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-end;
        padding-top: 0;
        gap: 2rem;
    }

    @media (max-width: 640px) {
        position: relative;
        flex-direction: column;
        height: auto;
        width: 100%;
        justify-content: center;

        .header-left {
            flex: 0 0 0;
            border-right: none;
            padding-right: 0;
            margin-right: 0;
            height: auto;
            padding-bottom: 1.5rem;
        }

        .header-middle {
            display: none;
        }

        .header-right {
            min-width: none;
            flex: 0 1 1;
            height: auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 1.5rem;
        }
    }
`;
